// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalizationCell_container__2SBmZ"};